import { getUnityBridgeCommands } from "../../lib/unityCommandBridge";

const FONT = "'DM Sans', sans-serif";

const btnStyle = {
  padding: "8px 14px",
  borderRadius: 8,
  border: "1px solid rgba(0,0,0,0.08)",
  background: "rgba(255,255,255,0.72)",
  color: "#334155",
  fontSize: 12,
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: FONT,
};

const floorBtnStyle = {
  ...btnStyle,
  padding: "9px 14px",
  background: "#FFFFFF",
  border: "1px solid rgba(37,99,235,0.35)",
  color: "#2563EB",
  fontSize: 13,
  fontWeight: 700,
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
};

const DEFAULT_ANCHOR = { top: 120 };

/**
 * Floor navigation + back/exit controls while Unity is in building inspection or first-person.
 */
export default function UnityInspectionBar({
  inspection,
  floorCount = 1,
  anchor = DEFAULT_ANCHOR,
  onBackToBuilding,
  onExitToMap,
}) {
  const cmds = getUnityBridgeCommands();
  if (!inspection || !cmds) return null;

  const inFirstPerson = inspection.mode === "firstperson";
  const inInspection = inspection.mode === "inspection";

  if (inFirstPerson) return null;

  if (!inInspection || floorCount <= 1) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: anchor.top,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 57,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 8,
        maxWidth: "calc(100vw - 32px)",
        padding: "8px 12px",
        borderRadius: 16,
        background: "rgba(255,255,255,0.84)",
        backdropFilter: "blur(14px) saturate(140%)",
        WebkitBackdropFilter: "blur(14px) saturate(140%)",
        border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 8px 28px rgba(0,0,0,0.14)",
      }}
    >
      {inInspection && floorCount > 1 && (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            <button type="button" style={floorBtnStyle} onClick={() => cmds.floorDown()}>
              Floor ↓
            </button>
            <button type="button" style={floorBtnStyle} onClick={() => cmds.floorUp()}>
              Floor ↑
            </button>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {Array.from({ length: floorCount }, (_, i) => (
              <button
                key={i}
                type="button"
                style={{ ...btnStyle, minWidth: 32, padding: "8px 10px" }}
                onClick={() => cmds.goToFloor(i)}
                title={`Go to floor ${i + 1}`}
              >
                {i + 1}
              </button>
            ))}
          </div>
        </>
      )}

      {inFirstPerson && (
        <button
          type="button"
          style={btnStyle}
          onClick={() => {
            cmds.returnToInspection();
            onBackToBuilding?.();
          }}
        >
          ← Back to building
        </button>
      )}

      {inFirstPerson && (
        <button
          type="button"
          style={{ ...btnStyle, borderColor: "rgba(77,184,181,0.4)" }}
          onClick={() => {
            onExitToMap?.();
            cmds.exitInspection();
          }}
        >
          Exit to map
        </button>
      )}
    </div>
  );
}
